import { useState } from 'react';
import { Link } from 'react-router-dom';
import { games } from '@/mocks/games';
import { categories } from '@/mocks/categories';

export default function FeaturedGames() {
  const [activeTab, setActiveTab] = useState('all');

  const filteredGames = activeTab === 'all'
    ? games.slice(0, 8)
    : games.filter((g) => g.category === activeTab).slice(0, 8);

  return (
    <section id="games" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100">
            精选游戏
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            探索 galagame 平台最受欢迎的热门游戏，总有你喜欢的一款
          </p>
        </div>

        <div className="flex items-center justify-center gap-1.5 mb-10 flex-wrap">
          {categories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => setActiveTab(cat.slug)}
              className={`px-4 py-2 text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                activeTab === cat.slug
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-200 text-foreground-400 hover:text-foreground-100 hover:bg-background-300'
              }`}
            >
              {cat.name}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-product-shop>
          {filteredGames.map((game) => (
            <Link
              key={game.id}
              to={`/category?tab=${game.category}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/50 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={game.image}
                  alt={game.name}
                  title={`${game.name} - galagame 游戏平台`}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3 flex items-center gap-1.5 flex-wrap">
                  {game.tags.slice(0, 2).map((tag) => (
                    <span
                      key={tag}
                      className="px-2 py-0.5 text-[10px] font-medium rounded-full bg-primary-500/80 text-background-50"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm font-semibold text-foreground-100 group-hover:text-primary-500 transition-colors duration-200">
                  {game.name}
                </h3>
                <p className="mt-1.5 text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                  {game.description}
                </p>
                <div className="flex items-center justify-between mt-3 pt-3 border-t border-background-200/30">
                  <div className="flex items-center gap-1">
                    <i className="ri-star-fill text-xs text-primary-500"></i>
                    <span className="text-xs text-foreground-300 font-medium">{game.rating}</span>
                  </div>
                  <span className="text-xs text-foreground-500">
                    <i className="ri-user-line mr-1"></i>
                    {game.players}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category"
            className="inline-flex items-center gap-2 px-6 py-2.5 text-sm font-semibold text-primary-500 border border-primary-500/30 hover:bg-primary-500/10 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部游戏
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}